import { render } from "./StakingView.vue?vue&type=template&id=0097dad5"
import script from "./StakingView.vue?vue&type=script&lang=js"
export * from "./StakingView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__